var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "home" },
    [
      _c("div", { staticClass: "banner" }, [
        _c("div", { staticClass: "banner-container" }, [
          _c("div", { staticClass: "download" }, [
            _c(
              "a",
              {
                attrs: {
                  target: "_blank",
                  href: "https://apps.apple.com/app/id1623853314"
                }
              },
              [_c("DownloadAppStore", { staticClass: "btn-download" })],
              1
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                attrs: {
                  target: "_blank",
                  href:
                    "https://a.app.qq.com/o/simple.jsp?pkgname=tech.xiangzi.life"
                }
              },
              [_c("DownloadAndroid", { staticClass: "btn-download" })],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "slogan" })
        ])
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { ref: "pro", staticClass: "pro" }, [
        _c("div", { staticClass: "container" }, [
          _c("h3", { staticClass: "title" }, [_vm._v("产品价格")]),
          _vm._v(" "),
          _c("div", { staticClass: "memberships" }, [
            _c(
              "div",
              { staticClass: "membership free" },
              [
                _c("h3", { staticClass: "member-title" }, [_vm._v("免费会员")]),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _vm._l(_vm.freeFeatures, function(item) {
                  return _c(
                    "div",
                    { key: item.path, staticClass: "member-feature" },
                    [
                      _c("CheckIcon", { staticClass: "check-icon" }),
                      _vm._v(" "),
                      _c("p", [_vm._v(_vm._s(item))])
                    ],
                    1
                  )
                })
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "membership pro" },
              [
                _c("h3", { staticClass: "member-title" }, [
                  _vm._v("年费高级会员")
                ]),
                _vm._v(" "),
                _vm._m(2),
                _vm._v(" "),
                _vm._l(_vm.annualProFeatures, function(item) {
                  return _c(
                    "div",
                    { key: item.path, staticClass: "member-feature" },
                    [
                      _c("CheckIcon", { staticClass: "check-icon" }),
                      _vm._v(" "),
                      _c("p", [_vm._v(_vm._s(item))])
                    ],
                    1
                  )
                }),
                _vm._v(" "),
                !_vm.user || !_vm.user.pro || _vm.user.pro == 0
                  ? _c(
                      "el-button",
                      {
                        staticClass: "btn btn-theme btn-purchase",
                        attrs: {
                          type: "text",
                          "data-toggle": "modal",
                          "data-target": "#purchase-modal"
                        },
                        on: {
                          click: function($event) {
                            return _vm.purchaseProduct("web_year")
                          }
                        }
                      },
                      [_vm._v("立即购买")]
                    )
                  : _vm.user.pro === 2
                  ? _c(
                      "el-button",
                      {
                        staticClass: "btn btn-theme btn-purchase",
                        attrs: {
                          type: "text",
                          "data-toggle": "modal",
                          "data-target": "#purchase-modal"
                        },
                        on: {
                          click: function($event) {
                            return _vm.purchaseProduct("web_year")
                          }
                        }
                      },
                      [_vm._v("立即续费")]
                    )
                  : _c(
                      "button",
                      {
                        staticClass: "btn btn-theme btn-disabled btn-purchase"
                      },
                      [_vm._v("已购买")]
                    )
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "membership ever" },
              [
                _c("h3", { staticClass: "member-title" }, [
                  _vm._v("捐赠终身荣誉会员")
                ]),
                _vm._v(" "),
                _vm._m(3),
                _vm._v(" "),
                _vm._l(_vm.everProFeatures, function(item) {
                  return _c(
                    "div",
                    { key: item.path, staticClass: "member-feature" },
                    [
                      _c("CheckIcon", { staticClass: "check-icon" }),
                      _vm._v(" "),
                      _c("p", [_vm._v(_vm._s(item))])
                    ],
                    1
                  )
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-theme btn-purchase",
                    attrs: {
                      "data-toggle": "modal",
                      "data-target": "#purchase-modal"
                    },
                    on: {
                      click: function($event) {
                        return _vm.purchaseProduct("web_ever")
                      }
                    }
                  },
                  [_vm._v("捐赠")]
                )
              ],
              2
            )
          ]),
          _vm._v(" "),
          _vm._m(4)
        ])
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "purchase-dialog-wrapper",
          attrs: { title: "高级会员", visible: _vm.showPurchaseDialog },
          on: {
            "update:visible": function($event) {
              _vm.showPurchaseDialog = $event
            },
            close: _vm.resetPurchasePopup
          }
        },
        [
          _c(
            "div",
            { staticClass: "purchase-dialog" },
            [
              _c(
                "el-form",
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "label",
                        {
                          staticClass: "my-1 mr-2",
                          attrs: { for: "inputGroupSelect01" }
                        },
                        [_vm._v("类型：")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-select",
                        {
                          staticClass: "custom-select",
                          attrs: { id: "inputGroupSelect01" },
                          on: {
                            change: function($event) {
                              return _vm.switchProduct()
                            }
                          },
                          model: {
                            value: _vm.selectedProduct.productId,
                            callback: function($$v) {
                              _vm.$set(_vm.selectedProduct, "productId", $$v)
                            },
                            expression: "selectedProduct.productId"
                          }
                        },
                        [
                          _c(
                            "el-option",
                            { attrs: { disabled: "", value: "" } },
                            [_vm._v("请选择订购类型")]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.products, function(option) {
                            return _c("el-option", {
                              key: option.productId,
                              attrs: {
                                value: option.productId,
                                label: option.title
                              }
                            })
                          })
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "label",
                        {
                          staticClass: "my-1 mr-2",
                          attrs: { for: "inputGroupSelect02" }
                        },
                        [_vm._v("数量：")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-select",
                        {
                          staticClass: "custom-select",
                          attrs: {
                            disabled: _vm.selectedProduct.maxNumber == 1,
                            id: "inputGroupSelect02"
                          },
                          model: {
                            value: _vm.selectedProduct.number,
                            callback: function($$v) {
                              _vm.$set(_vm.selectedProduct, "number", $$v)
                            },
                            expression: "selectedProduct.number"
                          }
                        },
                        [
                          _c(
                            "el-option",
                            { attrs: { disabled: "", value: "" } },
                            [_vm._v("请选择订购数量")]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.selectedProduct.maxNumber, function(n, i) {
                            return _c("el-option", {
                              key: i,
                              attrs: { value: n }
                            })
                          })
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-form-item", { staticClass: "total-price" }, [
                    _c("span", { staticClass: "currency" }, [_vm._v("￥")]),
                    _c("span", { staticClass: "price-integer" }, [
                      _vm._v(
                        _vm._s(
                          _vm.selectedProduct.price * _vm.selectedProduct.number
                        )
                      )
                    ]),
                    _c("span", { staticClass: "price-decimal" }, [
                      _vm._v(".00")
                    ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "dialog-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-pay btn-pay-wechat",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.pay(0)
                      }
                    }
                  },
                  [_vm._v("微信支付")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-pay btn-pay-alipay",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.pay(1)
                      }
                    }
                  },
                  [_vm._v("支付宝支付")]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showWechatQRCode,
                      expression: "showWechatQRCode"
                    }
                  ],
                  staticClass: "dialog-wxpay-qrcode"
                },
                [
                  _c("div", { staticClass: "qrcode-wrapper" }, [
                    _c("div", { attrs: { id: "wechat-pay-qrcode" } }),
                    _vm._v(" "),
                    _c("div", { staticClass: "top-left" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "top-right" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "bottom-right" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "bottom-left" })
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "qrcode-tips mr-2" }, [
                    _vm._v("微信扫码支付"),
                    _c("span", { staticClass: "price-integer ml-2" }, [
                      _vm._v(
                        _vm._s(
                          _vm.selectedProduct.price * _vm.selectedProduct.number
                        )
                      )
                    ]),
                    _c("span", { staticClass: "price-decimal mr-2" }, [
                      _vm._v(".00")
                    ]),
                    _vm._v("元")
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showAlipayWaiting,
                      expression: "showAlipayWaiting"
                    }
                  ],
                  staticClass: "dialog-alipay-waiting"
                },
                [
                  _c("div", { staticClass: "alipay-logo" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("支付宝支付中...")])
                ]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "specs" }, [
      _c("div", { staticClass: "spec-item" }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "spec-demo" }, [
            _c("img", {
              attrs: {
                src: "https://website.dislikeapp.com/feature-diary.png",
                alt: ""
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "spec-text" }, [
            _c("h3", { staticClass: "spec-title" }, [_vm._v("日记")]),
            _vm._v(" "),
            _c("div", { staticClass: "spec-content" }, [
              _c("p", [_vm._v("日记是最具体的生命的痕迹的记录。")]),
              _vm._v(" "),
              _c("p", { staticClass: "signature" }, [_vm._v("— 季羡林")]),
              _vm._v(" "),
              _c("p", [
                _vm._v("只能记录文字和照片，纯净、歇斯底里，像一本真正的日记。")
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "signature" }, [_vm._v("— 我说的")])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "spec-item" }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "spec-text" }, [
            _c("h3", { staticClass: "spec-title" }, [_vm._v("自传")]),
            _vm._v(" "),
            _c("div", { staticClass: "spec-content" }, [
              _c("p", [
                _vm._v("以一个旁观者的角度审视自己的人生，并以此为最大的幸福。")
              ]),
              _vm._v(" "),
              _c("p", [_vm._v("我想让这个世界记得，你曾经来过。")])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "spec-demo" }, [
            _c("img", {
              attrs: {
                src: "https://website.dislikeapp.com/feature-autobio.png",
                alt: ""
              }
            })
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "spec-item" }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "spec-demo" }, [
            _c("img", {
              attrs: {
                src: "https://website.dislikeapp.com/feature-nine.png",
                alt: ""
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "spec-text" }, [
            _c("h3", { staticClass: "spec-title" }, [_vm._v("九点")]),
            _vm._v(" "),
            _c("div", { staticClass: "spec-content" }, [
              _c("p", [
                _vm._v("每晚九点钟，夜色会和素未谋面的情绪一起拉开帷幕。")
              ]),
              _vm._v(" "),
              _c("p", [_vm._v("陌生人呀，我也为你祝福。")])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "spec-item" }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "spec-text" }, [
            _c("h3", { staticClass: "spec-title" }, [_vm._v("传记广场")]),
            _vm._v(" "),
            _c("div", { staticClass: "spec-content" }, [
              _c("p", [
                _vm._v("如今我们深夜饮酒，杯子碰到一起，都是梦破碎的声音。")
              ]),
              _vm._v(" "),
              _c("p", [_vm._v("不如，我们讲一讲彼此的故事吧...")])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "spec-demo" }, [
            _c("img", {
              attrs: {
                src: "https://website.dislikeapp.com/feature-bios.png",
                alt: ""
              }
            })
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "member-price" }, [
      _c("span", { staticClass: "currency" }, [_vm._v("￥")]),
      _vm._v(" "),
      _c("span", { staticClass: "price-integer" }, [_vm._v("0")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "member-price" }, [
      _c("span", { staticClass: "currency" }, [_vm._v("￥")]),
      _vm._v(" "),
      _c("span", { staticClass: "price-integer" }, [_vm._v("128")]),
      _vm._v(" "),
      _c("span", { staticClass: "bill-period" }, [_vm._v("/年")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "member-price" }, [
      _c("span", { staticClass: "currency" }, [_vm._v("￥")]),
      _vm._v(" "),
      _c("span", { staticClass: "price-integer" }, [_vm._v("798")]),
      _vm._v(" "),
      _c("span", { staticClass: "bill-period" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "notes" }, [
      _c("p", { staticClass: "notes-title" }, [_vm._v("订购须知")]),
      _vm._v(" "),
      _c("div", { staticClass: "notes-content" }, [
        _c("p", [
          _c("span", { staticClass: "number" }, [_vm._v("1.")]),
          _vm._v(
            "年费高级会员需连续订购满 10 年、或会员存续期内摇篮触发后 10 张永久照片空间方可生效；"
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _c("span", { staticClass: "number" }, [_vm._v("2.")]),
          _vm._v("高级会员资格在 iPhone、Android、Web 平台通用；")
        ]),
        _vm._v(" "),
        _c("p", [
          _c("span", { staticClass: "number" }, [_vm._v("3.")]),
          _vm._v("如购买后会员状态未及时生效，你可以尝试退出账号后重新登录；")
        ]),
        _vm._v(" "),
        _c("p", [
          _c("span", { staticClass: "number" }, [_vm._v("4.")]),
          _vm._v("考虑到服务的特殊性，会员购买后不支持退款，敬请谅解。")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }